(() => {
  'use strict';

  const membershipVariantIds = new Set([
    '44615629570341'
  ]);

  const messages = {
    beforeMembership:
      '通常商品がカートに入っています。通常商品の購入を完了するか、カートから削除してから有料会員にお申し込みください。',
    beforeRegular:
      '有料会員プランがカートに入っています。有料会員のお申し込みを完了するか、カートから削除してから通常商品を追加してください。',
    mixed:
      '有料会員プランと通常商品は同時に購入できません。どちらかをカートから削除して、別々にお手続きください。',
    failed:
      'カートの確認ができませんでした。通信状態を確認して、もう一度お試しください。'
  };

  const pendingForms = new WeakSet();
  const approvedForms = new WeakSet();
  let checkingMembership = false;

  function isMembershipId(id) {
    return membershipVariantIds.has(String(id));
  }

  function classify(items) {
    return {
      membership: items.some(
        (item) => isMembershipId(item.variant_id)
      ),
      regular: items.some(
        (item) => !isMembershipId(item.variant_id)
      )
    };
  }

  async function getCartState() {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart.js`, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Cart request failed');
    }

    const cart = await response.json();

    if (!Array.isArray(cart.items)) {
      throw new Error('Invalid cart response');
    }

    return classify(cart.items);
  }

  function stopEvent(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  function actionPath(form) {
    return new URL(form.action, window.location.origin)
      .pathname.replace(/\/+$/, '');
  }

  function isCheckoutSubmission(event, form) {
    const submitter = event.submitter;

    return (
      submitter?.name === 'checkout' ||
      (
        actionPath(form).endsWith('/cart') &&
        form.querySelector('input[name="checkout"]') !== null
      )
    );
  }

  // 有料会員の申込前に、通常商品がないか確認します。
  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest(
      'a[data-membership-apply]'
    );

    if (!link) return;

    stopEvent(event);

    if (checkingMembership) return;
    checkingMembership = true;

    try {
      const state = await getCartState();

      if (state.regular) {
        window.alert(messages.beforeMembership);
        return;
      }

      window.location.assign(link.href);
    } catch (error) {
      window.alert(messages.failed);
    } finally {
      checkingMembership = false;
    }
  }, true);

  // 商品追加と、カートからの購入手続きを確認します。
  document.addEventListener('submit', async (event) => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement)) return;

    // 確認済みフォームを、既存のテーマ処理へ渡します。
    if (approvedForms.has(form)) {
      approvedForms.delete(form);
      return;
    }

    const path = actionPath(form);
    const isAdd = /\/cart\/add(?:\.js)?$/.test(path);
    const isCheckout = isCheckoutSubmission(event, form);

    if (!isAdd && !isCheckout) return;

    stopEvent(event);

    if (pendingForms.has(form)) return;

    pendingForms.add(form);
    const submitter = event.submitter;

    try {
      const state = await getCartState();

      if (isAdd) {
        const data = new FormData(form);
        const variantId = data.get('id');

        // 対象商品を特定できない場合は追加を止めます。
        if (!variantId) {
          window.alert(messages.failed);
          return;
        }

        const addingMembership = isMembershipId(variantId);

        if (addingMembership && state.regular) {
          window.alert(messages.beforeMembership);
          return;
        }

        if (!addingMembership && state.membership) {
          window.alert(messages.beforeRegular);
          return;
        }
      }

      if (isCheckout && state.membership && state.regular) {
        window.alert(messages.mixed);
        return;
      }

      // 再送信時に、Dawnなどの既存処理を実行させます。
      approvedForms.add(form);

      try {
        if (submitter && submitter.form === form) {
          form.requestSubmit(submitter);
        } else {
          form.requestSubmit();
        }
      } finally {
        approvedForms.delete(form);
      }
    } catch (error) {
      window.alert(messages.failed);
    } finally {
      pendingForms.delete(form);
    }
  }, true);
})();
